/*
 * @Author: hw
 * @Date: 2024-04-16 16:46:21
 * @LastEditors: hw 315249041@qq.com
 * @LastEditTime: 2024-04-16 17:03:55
 * @FilePath: \dataview-viewer-test\src\locale\lang\en.js
 */
export default {
}